export default __webpack_public_path__ + "static/media/el1.af87faf3.png";